import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { withoutRoadmap, withRoadmap } from '../../data/site';
export function Comparison() {
  return <section className="bg-ice px-4 py-16 md:px-8 md:py-24" data-id="element-104" data-mp="30nd4qu4p61bi">
      <div className="mx-auto max-w-5xl" data-id="element-105" data-mp="2vpbla83czzzi">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[26px] font-black leading-tight text-navy sm:text-4xl" data-id="element-106" data-mp="2vojpaw5uo08p">
          The Difference Between Planning a Movement and Understanding Its Predictability
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-107" data-mp="2lxf9xvc9iddc">
          <div className="rounded-3xl bg-white p-6 ring-2 ring-danger/25 sm:p-8" data-id="element-108" data-mp="2h18faypbgoap">
            <div className="mb-5 flex items-center gap-3" data-id="element-109" data-mp="2czmveted79r0">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-danger text-white" data-id="element-110" data-mp="2cx0o8uvdyw9b">
                <XCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-111" data-mp="230nyg82yp2ju" />
              </span>
              <div data-id="element-112" data-mp="2330dacdfawso">
                <p className="text-xs font-bold uppercase text-danger" data-id="element-113" data-mp="3kj6zeygy678v">Before</p>
                <h3 className="font-display text-lg font-black leading-tight text-ink" data-id="element-114" data-mp="3paf7nr6jjmkg">Without a Structured Clinical Roadmap</h3>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-115" data-mp="3bklhn5jauw95">
              {withoutRoadmap.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink-muted" data-id="element-116" data-mp="3giwr3f5on4qu">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-117" data-mp="82tldey4rq55" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 text-white ring-2 ring-sky/40 sm:p-8" data-id="element-118" data-mp="3u90alyd6gkcl">
            <div className="mb-5 flex items-center gap-3" data-id="element-119" data-mp="31xi93lls80s">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-success text-white" data-id="element-120" data-mp="2iumqn4ljop1u">
                <CheckCircle2Icon className="h-6 w-6" aria-hidden="true" data-id="element-121" data-mp="2ntze9rk8q05h" />
              </span>
              <div data-id="element-122" data-mp="23rv2i4xf55hx">
                <p className="text-xs font-bold uppercase text-sky" data-id="element-123" data-mp="23qa8cgf0nokl">After</p>
                <h3 className="font-display text-lg font-black leading-tight" data-id="element-124" data-mp="1zp85zqpsywee">With Dental Predictability Roadmap™</h3>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-125" data-mp="1ux6zymj8a1wt">
              {withRoadmap.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-white/90" data-id="element-126" data-mp="1pzf63mz0w5pz">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-127" data-mp="1kyr3s55cg2gg" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-ink-muted" data-id="element-128" data-mp="1c20ag0i6f1pk">
          The goal isn’t to promise perfect outcomes. It’s to help you make more informed clinical decisions before problems develop.
        </p>

        <SectionCta label="Access My Clinical Roadmap — $27" data-id="element-129" data-mp="31g56gpgrm3bo" />
      </div>
    </section>;
}